import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DatacenterDetailsService } from './datacenter-details-vc.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../../refresh-shared-service';

@Component({
    selector: 'dps-datacenter-details-vc',
    providers: [DatacenterDetailsService],
    template: require('./datacenter-details-vc.html'),
    styles: [require('./datacenter-details-vc.scss')],
})
export class DatacenterDetails {

    @Input() entity: {
         'type': '',
         'entity_id': '',
         'vcenter_instanceId': ''
    };

    private items: any = [];
    private totalStorage: number = 0;
    private subscribeHandler: any;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private currentChanges: any;

    constructor(private translate: TranslateService,
                private activatedRoute: ActivatedRoute,
                private datacenterService: DatacenterDetailsService,
                private rss: RefreshSharedService) {
     translate.use(GlobalVariables.LOCALE);
            this.rsService = rss;
            this.currentClassName = 'DatacenterDetails';
    }

    ngOnInit() {
        console.log('init resource pool component');
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': true
        });
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName && this.currentChanges) {
            this.getData(this.currentChanges);
        }
    }


    fillStorageConsumptionDetails(items:any) {
        this.items = [];
        this.totalStorage = 0;
        for (let i = 0; i < items.length; i++) {
            this.items.push(items[i]);
            this.totalStorage += items[i].storage;
        }
    }

    ngOnChanges(changes) {
        this.currentChanges = changes;
        this.getData(changes);
    }

    getData(changes) {
        if (changes.entity && changes.entity.currentValue ) {
            this.entity = changes.entity.currentValue;
           if (changes.entity.currentValue.type === 'datacenter') {
               this.subscribeHandler = this.datacenterService.getDatacenterStorageConsumedDetails(
                                      changes.entity.currentValue.entity_id, changes.entity.currentValue.vcenter_instanceId)
                   .subscribe(
                     items => {
                         this.fillStorageConsumptionDetails(items);
                     });

           } else if (changes.entity.currentValue.type === 'cluster') {
               this.subscribeHandler = this.datacenterService.getClusterStorageConsumedDetails(
                                          changes.entity.currentValue.entity_id, changes.entity.currentValue.vcenter_instanceId)
                   .subscribe(
                     items => {
                         this.fillStorageConsumptionDetails(items);
                     });

           } else if (changes.entity.currentValue.type === 'computeresource') {
               this.subscribeHandler = this.datacenterService.getComputeResourceStorageConsumedDetails(
                                        changes.entity.currentValue.entity_id, changes.entity.currentValue.vcenter_instanceId)
                   .subscribe(
                     items => {
                         this.fillStorageConsumptionDetails(items);
                     });
           }
        }
    }
  ngOnDestroy() {
    this.rsService.resetParam();
    if (this.refreshSubscription) {
        this.refreshSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/datacenter/datacenter-details-vc.component.ts